import { koComponent } from "../../../../ko-utils";
import { getServerSideData } from "../../../page";
import ItemBase from "./itemBase";

class Header extends ItemBase {
    constructor(params) {
        super(params);
    }
}

export default koComponent('btn-item-header', Header);